export const supportedLocales = <const>['en', 'de', 'pt-BR'];

export const extendedSupportedLocales = <const>[
  'en',
  'en-STAGING',
  'pt-BR',
  'pt-STAGING',
  'de',
  'de-STAGING',
  'cimode',
];
